export default {
    en: {
        global: {
            header_default: 'OMNIplus ON',
            header_monitor: 'OMNIplus ON monitor',
            header_signal: '',
            fleet_management: 'For efficient fleet management.',
            menu_features: 'FEATURES',
            menu_customer_needs: 'CUSTOMER NEEDS',
            menu_signal_store: 'SIGNALSTORE',
        },

        driving_style: {
            nav_header: 'DRIVING STYLE ANALYSIS',
            nav_1: 'TotalScore',
            nav_2: 'EcoScore',
            nav_3: 'SafetyScore',
        },

        time_management: {
            nav_header: 'TIME MANAGEMENT',
            nav_1: 'Timekeeping',
            nav_2: 'Driver card <br>and mass storage download',
        },

        operational_planning: {
            nav_header: 'OPERATIONS PLANNING',
            nav_1: 'Route planning',
        },

        location_services: {
            nav_header: 'TRACKING SERVICES',
            nav_1: 'Location events',
            nav_2: 'Zone monitoring',
            nav_3: 'Trip recording',
            nav_4: 'Vehicle position',
        },

        operational_monitoring: {
            nav_header: 'OPERATIONS MONITORING',
            nav_1: 'Consumption',
            nav_2: 'Download minimum dataset',
            nav_3: 'Status of vehicle checks',
        },

        customer_needs: {
            box_1: 'I would like to fulfil the legal requirements for the driver card and mass storage data.',
            box_2: 'I want to have an overview of the driving and rest times of all drivers in order to use them more efficiently and avoid fines.',
            box_3: 'I need to know the individual driving behaviour of my drivers to recognize who has potential for improvements in order to drive more economically and safely.',
            box_4: 'I want to know where and in which situations my vehicles are located in order to respond quickly and flexible.',
            box_5: 'I want to have a simple route planning and greater efficiency by assigning routes to drivers and vehicles.',
            box_6: 'I want to know the consumption and remaining range of my vehicles in oder to have an overview about variable costs and identify potential savings.',
        },

        signalstore: {
            nav_header: 'SIGNAL STORE',
            nav_1: 'Data Package rFMS',
            nav_2: 'Data Package plus',
            nav_3: 'Data Package diagnostic',

            graphic_1: 'Bus data center',
            graphic_2: 'REST<br>(Historical data interface)',
            graphic_3: 'WSS<br>(real-time data interface)',
            graphic_4: 'Backend',
            graphic_5: 'Data Package rFMS',
            graphic_6: 'Data Package plus',
            graphic_7: 'Data Package diagnostic',
            graphic_8: 'Vehicle management system of customer',

            modal_rfms_header: 'Data Package rFMS',
            modal_rfms_copy_1: 'Standard vehicle data: information on alarms, powertrain, brake, windows, doors, flaps, battery and equipment as well as position data',
            modal_rfms_copy_2: 'Data points can be processed according to your individual needs in your own vehicle management system',
            modal_rfms_copy_3: 'Data points comply with the FMS standard',
            modal_rfms_copy_4: 'No retrofitting of third-party hardware in the vehicle necessary',
            modal_rfms_copy_5: 'Real time data as well as historical data',
            modal_rfms_info: 'The number and availability of data points depends on the vehicle equipment.',

            modal_plus_header: 'Data Package plus',
            modal_plus_copy_1: 'FMS standard data points as well as over 260 additional signals, e.g. signals on the chassis, wheels, powertrain, high-voltage systems, driver assistance systems, heating, ventilation, air conditioning, doors and more',
            modal_plus_copy_2: 'Data points can be processed according to your individual needs in your own vehicle management system',
            modal_plus_copy_3: 'Real time data as well as historical data',
            modal_plus_copy_4: 'No retrofitting of third-party hardware in the vehicle necessary',
            modal_plus_info: 'The number and availability of data points depends on the vehicle equipment.',

            modal_diag_header: 'Data Package diagnostic',
            modal_diag_copy_1: 'The data package diagnostic provides a first error analysis of the control units in case of repair is made and presented in a so-called short test. It contains the hardware and software numbers of the electronic control units as well as the active and stored error codes including error description. The diagnostic short test is available in the formats JSON and PDF.',
            modal_diag_info: 'Note: The short test gives only a first indication of the health of the vehicle.<br>For a detailed diagnosis, a workshop appointment is required.',

            modal_realtime_header: 'Real-time and historical Data Interface',
            modal_realtime_subheader_1: 'REST = representational state transfer',
            modal_realtime_subheader_2: 'WSS = Secure Web Socket',
            modal_realtime_copy_1: '- Retrieve signals that are no more than 2 weeks old<br>- Transmission frequency of the data in 2 Hz<br>- Provides data in JSON format',
            modal_realtime_copy_2: '- Real-time data<br>- Transmission frequency of the data in 2 Hz<br>- Provides data in JSON format',
            modal_realtime_info: 'Note: The new online vehicle data interfaces of OMNIplus ON Signal Store is available for use in all vehicles with code EWT2.<br>Required for the integration of the eCitaro into charging or depot management systems.',
        }
    },

    de: {
        global: {
            header_default: 'OMNIplus ON',
            header_monitor: 'OMNIplus ON monitor',
            header_signal: '',
            fleet_management: 'Für effizientes Flottenmanagement.',
            menu_features: 'FUNKTIONEN',
            menu_customer_needs: 'KUNDENBEDÜRFNISSE',
            menu_signal_store: 'SIGNALSTORE',
        },

        driving_style: {
            nav_header: 'FAHRSTIL<br>BEWERTUNG',
            nav_1: 'TotalScore',
            nav_2: 'EcoScore',
            nav_3: 'SafetyScore',
        },

        time_management: {
            nav_header: 'ZEIT-<br>MANAGEMENT',
            nav_1: 'Zeit einhalten',
            nav_2: 'Download Fahrerkarte <br>und Massenspeicher ',
        },

        operational_planning: {
            nav_header: 'EINSATZ-<br>PLANUNG',
            nav_1: 'Routenplanung',
        },

        location_services: {
            nav_header: 'ORTUNGS-<br>DIENSTE',
            nav_1: 'Standortereignisse',
            nav_2: 'Zonenüberwachung',
            nav_3: 'Fahrtenaufzeichnung',
            nav_4: 'Fahrzeugposition',
        },

        operational_monitoring: {
            nav_header: 'EINSATZ-<br>ÜBERWACHUNG',
            nav_1: 'Verbrauch',
            nav_2: 'Download Minimaldatenset',
            nav_3: 'Status der Fahrzeugkontrollen',
        },

        customer_needs: {
            box_1: 'Ich möchte die gesetzlichen Anforderungen für die Fahrerkarte und Massenspeicherdaten erfüllen.',
            box_2: 'Ich möchte einen Überblick über die Lenk- und Ruhezeiten aller Fahrer haben, um diese effizienter einzusetzen und Bußgelder zu vermeiden.',
            box_3: 'Ich muss das individuelle Fahrverhalten meiner Fahrer kennen, um zu sehen, bei welchem Verbesserungspotenzial besteht, um wirtschaftlicher und sicherer zu fahren.',
            box_4: 'Ich möchte wissen, wo und in welchen Situationen sich meine Fahrzeuge befinden, um schnell und flexibel reagieren zu können.',
            box_5: 'Ich möchte eine einfache Routenplanung und höhere Effizienz durch das Zuordnen von Routen zu Fahrern und Fahrzeugen.',
            box_6: 'Ich möchte den Verbrauch und die Restreichweite meiner Fahrzeuge wissen, um einen Überblick über die variablen Kosten zu haben und Einsparpotenziale zu identifizieren.',
        },

        signalstore: {
            nav_header: 'SIGNAL STORE',
            nav_1: 'Data Package rFMS',
            nav_2: 'Data Package plus',
            nav_3: 'Data Package diagnostic',

            graphic_1: 'Bus data center',
            graphic_2: 'REST<br>(Schnittstelle für historische Daten)',
            graphic_3: 'WSS<br>(Schnittstelle für Real-Time-Daten)',
            graphic_4: 'Backend',
            graphic_5: 'Data Package rFMS',
            graphic_6: 'Data Package plus',
            graphic_7: 'Data Package diagnostic',
            graphic_8: 'Fahrzeugmanagementsystem des Kunden',

            modal_rfms_header: 'Data Package rFMS',
            modal_rfms_copy_1: 'Serienmäßige Fahrzeugdaten: Informationen zu Warnanzeigen, Antriebsstrang, Bremse, Fenstern, Türen, Klappen, Batterie und Ausstattung sowie Positionsdaten.',
            modal_rfms_copy_2: 'Datenpunkte können gemäß Ihren individuellen Bedürfnissen in Ihrem eigenen Fahrzeugmanagementsystem verarbeitet werden.',
            modal_rfms_copy_3: 'Datenpunkte entsprechen dem FMS-Standard.',
            modal_rfms_copy_4: 'Kein Nachrüsten von Hardware von Drittanbietern im Fahrzeug erforderlich.',
            modal_rfms_copy_5: 'Sowohl Real-Time-Daten als auch historische Daten',
            modal_rfms_info: 'Die Anzahl und Verfügbarkeit der Datenpunkte ist von der Fahrzeugausstattung abhängig.',

            modal_plus_header: 'Data Package plus',
            modal_plus_copy_1: 'FMS-Standard-Datenpunkte sowie über 260 zusätzliche Datenpunkte, z. B. zu Fahrwerk, Rädern, Antriebsstrang, Hochvoltsystemen, Fahrerassistenzsystemen, Heizung, Lüftung, Klimaanlage, Türen und mehr.',
            modal_plus_copy_2: 'Datenpunkte können gemäß Ihren individuellen Bedürfnissen in Ihrem eigenen Fahrzeugmanagementsystem verarbeitet werden.',
            modal_plus_copy_3: 'Sowohl Real-Time-Daten als auch historische Daten',
            modal_plus_copy_4: 'Kein Nachrüsten von Hardware von Drittanbietern im Fahrzeug erforderlich.',
            modal_plus_info: 'Die Anzahl und Verfügbarkeit der Datenpunkte ist von der Fahrzeugausstattung abhängig.',

            modal_diag_header: 'Data Package diagnostic',
            modal_diag_copy_1: 'Das Data Package diagnostic liefert im Reparaturfall eine erste Fehleranalyse der Steuergeräte in Form eines sogenannten Kurztests. Sie enthält die Hard- und Softwarenummern der elektronischen Steuergeräte sowie die aktiven und gespeicherten Fehlercodes inklusive Fehlerbeschreibung. Der diagnostische Kurztest ist in den Dateiformaten JSON und PDF verfügbar.',
            modal_diag_info: 'Hinweis: Der Kurztest gibt nur einen ersten Hinweis auf den Zustand des Fahrzeugs.<br> Für eine detaillierte Diagnose ist ein Werkstatttermin erforderlich.',

            modal_realtime_header: 'Real-time and historical Data Interface',
            modal_realtime_subheader_1: 'REST = repräsentativer Zustandstransfer',
            modal_realtime_subheader_2: 'WSS = Secure Web Socket',
            modal_realtime_copy_1: '- Abrufen von Signalen, die nicht älter als 2 Wochen sind.<br>- Übertragungsfrequenz der Daten in 2 Hz<br>- Liefert Daten im JSON-Format',
            modal_realtime_copy_2: '- Echtzeitdaten<br>- Übertragungsfrequenz der Daten in 2 Hz<br>- Liefert Daten im JSON-Format',
            modal_realtime_info: 'Hinweis: Die neuen Online-Fahrzeugdatenschnittstellen von OMNIplus ON Signal Store sind für den Einsatz in allen Fahrzeugen mit dem Code EWT2 verfügbar.<br>Erforderlich für die Integration des eCitaro in Lade- oder Depotmanagementsysteme.',
        }
    }
}